// extracted by mini-css-extract-plugin
export default {"filter":"AssigneeFilter_filter__C1tmo"};